window._bl = { partner: 'monicaandandy.com' };

for (button of document.getElementsByClassName("add-to-babylist")) {
  button.addEventListener("click", function(event) {
	var imageContainer = $('.product-image-main');
    var imageUrl = $('.slick-current .product-image-main .photo-zoom-link').attr('data-zoom-size');
    var productPrice = $('.product-single__meta .product__price').text();
    var productTitle = $('.product-single__title').text();
    var variantTitle = $('.variant-input-wrap input[type="radio"]:checked').attr('value');
    
    bl.addToRegistry({     
      images: imageUrl,
      price: button.dataset.price,
      title: productTitle + " - " + variantTitle,
      url: button.dataset.url,
    });
    event.preventDefault();
  });
}
